import { render } from "./ShortcutHelpMenu.vue?vue&type=template&id=c03a88c4&scoped=true&lang=pug"
import script from "./ShortcutHelpMenu.vue?vue&type=script&lang=js"
export * from "./ShortcutHelpMenu.vue?vue&type=script&lang=js"

import "./ShortcutHelpMenu.vue?vue&type=style&index=0&id=c03a88c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c03a88c4"]])

export default __exports__